import React from 'react';

const PhotoItem = ({ photo, onClick }) => {
  return (
    <div className="photo-item" onClick={onClick}>
      <div className="photo-thumbnail">
        <img
          src={photo.thumbnail}
          alt={photo.filename}
          loading="lazy"
          className="photo-image"
        />
      </div>
    </div>
  );
};

export default PhotoItem;